module.exports = __webpack_public_path__ + "img/Education.4ed7132d.svg";